import { resolveResponsiveProp } from '../../internal/responsive-props';
import styles from './useGridGap.module.less';
export var useGridGap = function useGridGap(spacing) {
  return resolveResponsiveProp(spacing, 'grid-gap', styles);
};